export default "__VITE_ASSET__2VTB1RS9__"